<template>
  <div class="content-box">
    <p class="little-title">{{ $t('programOverview') }}</p>
    <p>{{ $t('overViewInfo') }}</p>

    <p class="little-title">{{ $t('duty') }}</p>
    <p class="duty-info">{{ $t('dutyInfo') }}</p>

    <p class="lists" v-for="(duty,index) in $t('dutyList')">
      <span class="index">{{ index+1 }}.</span>{{ duty }}
    </p>

    <p class="lists unsuitable" v-for="unsuitable in $t('unsuitableList')">
      <span class="index"></span>{{ unsuitable }}
    </p>
    <p class="remind">{{ $t('remind') }}</p>

    <p class="little-title">{{ $t('acceptableMethods') }}</p>
    <p class="fallowingMethods">{{ $t('fallowingMethods') }}</p>
    <p class="lists" v-for="(methods,index) in $t('methodsList')">
      <span class="index">{{ index+1 }}.</span>{{ methods }}
    </p>

    <p class="little-title">{{ $t('modification') }}</p>
    <p>{{ $t('modificationInfo') }}</p>
  </div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'affiliate-policy',
    locales
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .content-box {
    max-width: 1180px;
    margin: 1.6rem auto 1.8rem;
  }

  p {
    font-size: .16rem;
    color: #111;
    letter-spacing: 0;
    line-height: .24rem;
  }

  .little-title {
    font-size: .32rem;
    font-weight: 600;
    color: #333333;
    letter-spacing: 0;
    margin-bottom: .24rem;
    margin-top: .64rem;
    line-height: .48rem;
    &:first-child {
      margin-top: 0;
    }
  }

  .duty-info {
    margin-bottom: .24rem;
  }

  .lists {
    position: relative;
    padding-left: .16rem;
    margin-bottom: .24rem;
    span.index {
      position: absolute;
      left: 0;
      top: 0;
    }
  }

  .unsuitable {
    padding-left: .4rem;
    margin-bottom: .16rem;
    span.index {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #333;
      left: .16rem;
      top: .07rem;
    }
  }
  
  .remind {
    padding-top: .08rem;
  }

  .fallowingMethods {
    margin-bottom: 0.24rem;
  }

  @media (max-width: 1228px) {
    .content-box {
      padding: 0 24px;
    }
  }
  @media (max-width: 991px) {
    .content-box {
      margin: .24rem auto .8rem;
    }
    .little-title {
      font-size: 20px;
      color: #111111;
      line-height: 28px;
      margin-bottom: .08rem;
      margin-top: .24rem;
    }
    p {
      font-size: 14px;
      color: #666666;
      line-height: 20px;
    }
    .duty-info, .lists, .fallowingMethods {
      margin-bottom: .16rem;
    }
    .unsuitable {
      padding-left: .15rem;
      margin-bottom: .12rem;
      span.index {
        width: 6px;
        height: 6px;
        left: .05rem;
      }
    }
    .remind {
      padding-top: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// AffiliatePolicy.vue?221c7556